const Footer = () => {
    return (
      <footer className="bg-primary py-12 ">
        <div className="container mx-auto">
          <p className="text-white font-semibold text-center">Copyright &copy; E-Commerce Assembler Pill 2023</p>
        </div>
      </footer>
    )
  }
  
  export default Footer;